<script>
  import { onMount } from 'svelte';
  import { PLAYERBOARD_MAP } from "../../constants/playerboards";
  import SelectablePlayerBoard from "../components/SelectablePlayerBoard.svelte";
  import { PlayersStore, PlayerId, SetupStore } from "../stores/gameStore";

  let playerboards;

  $: {
    playerboards = PLAYERBOARD_MAP.map((pb) => {
      const state = $SetupStore.playerboards;
      const playerId = Object.keys(state).find(
        (pid) =>
          state[pid]?.board_ID === pb.front || state[pid]?.board_ID === pb.back
      );
      const flipped = state[playerId]?.board_ID === pb.back;
      if (!playerId) return { ...pb, flipped: true };
      const color = "#" + $PlayersStore[playerId].color;
      const selected = $PlayerId === playerId;

      return { ...pb, color, flipped, selected, disabled: !selected };
    });
  }

  $: selected = $SetupStore.playerboards[$PlayerId];

  let gameScreenElement; // Reference to the GameScreen element
  let containerWidth = 0;
  let layoutNarrow = false; // Whether to flip the crafting table

  // Dynamically check if crafting table exceeds the screen width
  const checkLayout = () => {
    const parentElement = gameScreenElement.parentElement;
    containerWidth = parentElement.offsetWidth;
    
    layoutNarrow = 1008 > containerWidth;
  };

  onMount(() => {
    // Set up window resize listener
    window.addEventListener('resize', checkLayout);

    // Initial check on mount
    checkLayout();

    return () => {
      window.removeEventListener('resize', checkLayout);
    };
  });

  const textExplanation = _('Flip between generic and advanced versions.');
  const textReady = _('Ready');
  const textWait = _('Please wait for the other players to be ready.');

</script>

<div
bind:this={gameScreenElement}
>
  <div
  class="whiteblock box"
  class:narrow={layoutNarrow}
  >
    {textExplanation}  

    {#if selected?.board_ID}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div
        class="btn check"
        on:click={(e) => {
          e.preventDefault();
          window.GAME.bgaPerformAction("selectReady", {
            player_ready: !selected.player_ready,
            playerId: $PlayerId,
          });
        }}
        style:background-color={selected.player_ready ? "lime" : "white"}
      >
        {textReady}
      </div>
      {#if selected.player_ready}
        {textWait}
      {/if}
    {/if}
  </div>
  <div
  class="grid"
  class:narrow={layoutNarrow}
  >
    {#each playerboards as board}
      <SelectablePlayerBoard
        disabled={board.disabled}
        selected={board.selected}
        color={board.color}
        flipped={board.flipped}
        offset={$SetupStore.data.playerBoards[board.front].offset}
        offsetBack={$SetupStore.data.playerBoards[board.back].offset}
        board = {board}
        onclick={() => {
          if (board.selected) return;
          window.GAME.bgaPerformAction("selectPlayerboard", {
            boardId: board.back,
            playerId: $PlayerId,
          });
        }}
        onflip={() => {
          window.GAME.bgaPerformAction("selectPlayerboard", {
            boardId: board.flipped ? board.front : board.back,
            playerId: $PlayerId,
          });
        }}
      />
    {/each}
  </div>
</div>

<style>
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 0.5rem;
  }

  .grid.narrow {
    grid-template-columns: 1fr;
    justify-items: center;
  }

  .box {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  .box.narrow {
    flex-direction: column;
    align-items: center;
  }
</style>
